export default __webpack_public_path__ + "static/media/london-climate-action-week.ef4ee144.jpg";